import { ActionIcon, Tooltip, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';

// Выбор темы запоминается в браузере (localStorage Mantine)
export function ThemeToggle() {
  const { setColorScheme } = useMantineColorScheme();
  const scheme = useComputedColorScheme('light');
  const dark = scheme === 'dark';
  return (
    <Tooltip label={dark ? 'Светлая тема' : 'Тёмная тема'}>
      <ActionIcon variant="default" size="lg" radius="md" onClick={() => setColorScheme(dark ? 'light' : 'dark')} aria-label="Переключить тему">
        {dark ? <IconSun size={18} /> : <IconMoon size={18} />}
      </ActionIcon>
    </Tooltip>
  );
}
